import mutations from './dataAssetInventory.mutations'
import actions from './dataAssetInventory.actions'
import getters from './dataAssetInventory.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
